import {Link, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {doc, getDoc} from "firebase/firestore";
import {db} from "../../firebase.config";
import {displayProjectTypeMap} from "../../utils/project-type.utils";
import CTA from "../../components/CTA/CTA";
import Footer2 from "../../components/Footer/Footer2";

function ProjectPage() {
  const {projectId} = useParams();
  const [project, setProject] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  

  useEffect(function() {
    async function fetchProject() {
      try {
        const docRef = doc(db, 'projects', projectId);
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
          setError('Project not found');
          setLoading(false);
          return;
        }

        const projectData = docSnap.data();
        // Sort images by ordinal property
        if (projectData.images) {
          projectData.images = [...projectData.images].sort((a, b) => a.ordinal - b.ordinal);
        }
        setProject(projectData);
      } catch (err) {
        console.error('Error fetching project:', err);
        setError('Failed to load project');
      } finally {
        setLoading(false);
      }
    }
    
    fetchProject();
  }, []);
  
  function onPrevImage() {
    if (selectedImageIndex > 0) {
      setSelectedImageIndex(selectedImageIndex - 1);
    }
  }
  
  function onNextImage() {
    if (selectedImageIndex < project.images.length - 1) {
      setSelectedImageIndex(selectedImageIndex + 1);
    }
  }
  
  return (
    <>
      <div className={"relative mb-[44.9vh] md:mb-[30vh] z-[30] bg-white"}>
        {loading ? (
          <div className={'w-screen h-screen flex justify-center items-center'}>
            <p>Loading...</p>
          </div>
        ) : error ? (
          <div className={'w-screen h-screen flex justify-center items-center'}>
            <p>{error}</p>
          </div>
        ) : (
          <div className={"mt-[110px] px-8 flex items-center flex-col pb-20"}>
            <Link to={"/recent-projects"} className={"text-sm text-[#081542] underline mt-8 self-start transition duration-300 ease-in-out hover:opacity-70"}>&larr; Back to Projects</Link>
            <h1 className={"font-semibold pt-4 text-[#081542] text-[2.5rem]"}>{displayProjectTypeMap[project.projectType]}</h1>
            <div className="w-fit px-2 py-1 text-xs font-medium bg-[#8fa4b8] text-white rounded-[5px] mt-2 mb-8">{project.header}</div>

            <img src={project.images[selectedImageIndex].url} alt={"Project Image"} className={"w-full sm:w-[80%] lg:w-[70%] xl:w-[60%] rounded-[5px] h-auto aspect-[16/9] object-cover"} />
            {project.images.length > 1 && (
              <div className={"w-full sm:w-[80%] lg:w-[70%] xl:w-[60%] flex justify-between"}>
                <div className="flex gap-2 items-center overflow-x-auto pt-4 pb-2 flex-1 justify-center">
                  {project.images.map((image, index) => (
                    <img
                      key={index}
                      src={image.url}
                      alt={`Thumbnail ${index + 1}`}
                      onClick={() => setSelectedImageIndex(index)}
                      className={`h-[40px] sm:h-[52px] lg:h-[80px] w-[60px] sm:w-[80px] lg:w-[120px]  object-cover rounded cursor-pointer transition-all ${
                        selectedImageIndex === index
                          ? 'ring-2 ring-[#081542] opacity-100'
                          : 'opacity-60 hover:opacity-100'
                      }`}
                    />
                  ))}
                </div>
              </div>
            )}

            {project.description && <p
              className={"text-[#081542] w-full sm:w-[70%] lg:w-[60%] xl:max-w-[50%] text-center pt-12"}>{project.description}</p>}
          </div>
        )}
        <CTA/>
      </div>

      <Footer2/>
    </>
  )
}

export default ProjectPage;